<template>
  <v-container fill-height fluid>
    <v-row v-if="errorMessage">
      <v-col cols="12">
        <message-alert :message="errorMessage" alert-type="error" />
      </v-col>
    </v-row>
    <v-row class="mb-0">
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="loginDetails.email"
          :label="t('Email Address')"
          :error-messages="getErrorMessages('email')"
          prepend-icon="mdi-email"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="my-0">
      <v-col cols="12" class="py-0">
        <v-text-field
          v-model="loginDetails.password"
          :label="t('Password')"
          type="password"
          :error-messages="getErrorMessages('password')"
          prepend-icon="mdi-lock"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row class="my-0">
      <v-col cols="12">
        <v-btn
          :disabled="!canLogin"
          color="#299347"
          class="mr-4 white--text"
          @click="login"
          block
          large
        >
          {{ t("Login") }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <router-link to="/forgot-password">{{
          t("Forgot your Password?")
        }}</router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="text-center">
        <v-btn
          color="#f2a41f"
          class="mr-4"
          @click="$router.push('/register')"
          block
          large
        >
          {{ t("Register") }}
        </v-btn>
      </v-col>
    </v-row>
    <overlay-custom
      :active="loading"
      :message="loadingMessage"
    ></overlay-custom>
  </v-container>
</template>

<script>
import MessageAlert from "../components/alert/MessageAlert";
import { isEmpty } from "lodash";
import { mapErrors } from "@/lib/formUtils";
import OverlayCustom from "../components/OverlayCustom";

export default {
  name: "LoginView",
  components: { OverlayCustom, MessageAlert },
  data() {
    return {
      loginDetails: {
        email: null,
        password: null,
      },
      errors: [],
      errorMessage: null,
      loading: false,
      loadingMessage: null,
    };
  },
  computed: {
    canLogin() {
      return (
        !isEmpty(this.loginDetails.email) &&
        !isEmpty(this.loginDetails.password)
      );
    },
  },
  methods: {
    async login() {
      const that = this;
      that.errorMessage = null;
      that.errors = [];
      that.loading = true;
      that.loadingMessage = that.t("Logging in...");

      this.$store
        .dispatch("login", this.loginDetails, { root: true })
        .then(() => {
          that.$router.push("/dashboard");
        })
        .catch((error) => {
          that.mapErrors(error.data);
        })
        .finally(() => {
          that.loading = false;
          that.loadingMessage = null;
        });
    },
    mapErrors(errorDetails) {
      this.errors = mapErrors(errorDetails);
      this.errorMessage = errorDetails.message;
    },
    hasError(field) {
      return !isEmpty(this.errors[field]);
    },
    getErrorMessages(field) {
      return this.errors[field];
    },
  },
};
</script>
